import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';

import { PageHeader, Pagination } from '../../components';
import DataTable from '../../components/DataTable/DataTable';
import useComponentState from '../../utils/useComponentState';
import { getInboundSms } from '../../api/inboundSms';
import {
  INITIAL_STATE,
  TABLE_HEADING,
  NOT_FOUND_MESSAGE,
  PAGE_SIZE,
  DEFAULT_FETCH_ERROR_MESSAGE,
} from './ViewInboundMessagesConstants';

import styles from './ViewInboundMessages.module.scss';

const ViewInboundMessages = ({ auth }) => {
  const [state, setState] = useComponentState(INITIAL_STATE);
  const { inboundMessages, currentPage, totalPages, loading, fetchError } = state;
  // ROLE_CLIENT_CAMPAIGN_ADMINISTRATOR only has clientDetails on their own
  // user record, so scoping by it here limits them to their own client's
  // messages; ROLE_THYAGA_ADMINISTRATOR has none and sees every client's.
  const clientId = auth?.details?.clientDetails?.clientId || null;

  const runFetch = async (page) => {
    setState({ loading: true, fetchError: '' });
    try {
      const response = await getInboundSms(auth.token, page, PAGE_SIZE, clientId);
      setState({
        inboundMessages: response.list || [],
        totalPages: response.totalPageCount || 0,
        currentPage: response.pageNo || 0,
      });
    } catch (err) {
      setState({
        inboundMessages: [],
        totalPages: 0,
        currentPage: 0,
        fetchError: err?.message || DEFAULT_FETCH_ERROR_MESSAGE,
      });
    }
    setState({ loading: false });
  };

  useEffect(() => {
    runFetch(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePagination = (page) => {
    runFetch(page);
  };

  const handleRefresh = () => {
    runFetch(currentPage);
  };

  return (
    <div className={styles.root_div}>
      <PageHeader text='Inbound Messages' />

      <div className={styles.toolbar}>
        <Button
          variant='outline-secondary'
          onClick={handleRefresh}
          disabled={loading}
          title='Refresh'
        >
          <FontAwesomeIcon icon={faSyncAlt} spin={loading} />
        </Button>
      </div>

      <div className={`${styles.table_wrapper} table-fit`}>
        <DataTable
          tableData={inboundMessages}
          tableheading={TABLE_HEADING}
          tag='inbound-sms'
          fetchError={fetchError}
          notFoundMessage={NOT_FOUND_MESSAGE}
          search_filter_loading={loading}
        />
      </div>

      {!loading && !fetchError && (
        <div className={styles.pagination_wrapper}>
          <Pagination
            pageCount={totalPages}
            onChange={handlePagination}
            currentPage={currentPage}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth.auth,
  };
};

export default connect(mapStateToProps)(ViewInboundMessages);
